export default "https://cdn-static.gokick.com/assets/7e5886a8604a8a782ca6a0de4eecb197b7d69c39/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";